export type IPasswordSettingsResources = typeof PasswordSettingsResources;

export const PasswordSettingsResources = {
    oldPasswordText: "Obecne hasło",
    newPasswordText: "Nowe hasło",
    currentPasswordText: "Obecne hasło",
    confirmPasswordText: "Powtórz nowe hasło",
    confirmButton: "Zapisz",
    saveChangesMessage: "Zmiany zostały zapisane.",
    title: "Zmień hasło",
    description: "Ustaw nowe hasło do konta goodie",
    successTitle: "Hasło zostało zmienione",
    successButton: "Wróć do goodie",
    passwordRequiredError: "Hasło jest wymagane",
    passwordInvalidSizeError: "Hasło powinno mieć co najmniej 6 znaków",
    newPasswordIsTheSameAsOldOne: "Nowe hasło musi różnić się od starego",
    passwordsInvalidError: "Hasła muszą się zgadzać. Wprowadź ponownie",
    passwordsNotMatchError: "Hasła różnią się",
};
